import React from 'react';
import { useSelector } from 'react-redux';

import AdminDashboard from './DashboardComponents/AdminDashboardPage';  
import StudioDashboard from './DashboardComponents/StudioDashboardPage';
import UserDashboard from './DashboardComponents/UserDashboardPage';


const DashboardView = ({ onMenuSelect }) => {
    const userRole = useSelector(state => state.auth.role || state.auth.roleCode);
  
    if (userRole === 'ADMIN') {
      return <AdminDashboard onMenuSelect={onMenuSelect} />;
    }
    if (userRole === 'STUDIO') {
      return <StudioDashboard onMenuSelect={onMenuSelect} />;
    }
    return <UserDashboard onMenuSelect={onMenuSelect} />;
  };

  export default DashboardView;

  